import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

const data = [
  { name: 'January', value: 186 },
  { name: 'February', value: 305 },
  { name: 'March', value: 237 },
  { name: 'April', value: 73 },
  { name: 'May', value: 209 },
  { name: 'June', value: 214 },
];

export default function VerticalBarChart() {
  return (
    <div style={{ width: '100%', height: '350px', minHeight: '300px' }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar
            dataKey="value"
            fill="#00bfff"
            radius={[10, 10, 0, 0]} 
            barSize={20} 
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
